module.exports = __webpack_public_path__ + "static/img/5.75ea45f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/2/3/eng/5.png
// module id = cAf0
// module chunks = 0